<template>
	<v-ons-page>
		<div class="background bg-login"></div>
		<v-ons-list>
			<v-ons-list-item class="menu-profil" @click="navTo('myProfile')">
				<div class="left">
					<img class="list-item__thumbnail" :src="avatar">
				</div>
				<div class="center">
					{{names}}
				</div>
			</v-ons-list-item>
		</v-ons-list>
		<v-ons-list>
			<v-ons-list-header>Navigation</v-ons-list-header>
			<v-ons-list-item @click="navTo('home')">
				<div class="left icon"><v-ons-icon icon="fa-home" class="list-item__icon"></v-ons-icon></div>
				<div class="center">Dashboard</div>
			</v-ons-list-item>
			<v-ons-list-item @click="navTo('collections')" >
				<div class="left icon"><v-ons-icon icon="fa-th-large" class="list-item__icon"></v-ons-icon></div>
				<div class="center">Collections</div>
			</v-ons-list-item>
		</v-ons-list>
		<v-ons-list>
			<v-ons-list-header>Settings</v-ons-list-header>
			<v-ons-list-item tappable @click="logoutAlert = true">
				<div class="left icon"><v-ons-icon icon="fa-sign-out-alt" class="list-item__icon"></v-ons-icon></div>
				<div class="center">Logout</div>
			</v-ons-list-item>

		</v-ons-list>
		<div class="version">v.{{version}}</div>
		<v-ons-alert-dialog modifier="rowfooter" :visible.sync="logoutAlert">
			<span slot="title">Are you sure want to logout?</span>
			<template slot="footer">
				<v-ons-alert-dialog-button @click="logoutAlert = false">Cancel</v-ons-alert-dialog-button>
				<v-ons-alert-dialog-button @click="logOut">Yes</v-ons-alert-dialog-button>
			</template>
		</v-ons-alert-dialog>
	</v-ons-page>
</template>

<script>
	import CollectionsHome from "../views/collections/CollectionsHome";
	import DashboardHome from "../views/dashboard/DashboardHome";
	import Login from "../views/login/Login";
	import MyProfile from "../views/profile/MyProfile";
	export default {
		name: "MainMenu",
		data() {
			return {
				logoutAlert: false
			};
		},
		methods : {
			logOut(){
				this.logoutAlert = false;

				this.$deleteCookie('access_token');
				this.$deleteCookie('login_name');
				this.$deleteCookie('refresh_token');
				this.$deleteCookie('access_exp_time');

				this.$store.commit('splitter/toggle');
				this.$store.commit('navigator/reset');
				this.$store.commit('navigator/push', {
					extends: Login,
				});

			},
			navTo(destination){
				let destinationComponent = {};
				let resetStack = true;
				switch (destination) {
					case 'collections':
						destinationComponent = CollectionsHome;
						break;
					case 'home':
						destinationComponent = DashboardHome;
						break;
					case 'myProfile':
						destinationComponent = MyProfile;
						resetStack = false;
						break;
				}
				if(resetStack){
					this.$store.commit('navigator/reset');
				}

				this.$store.commit('navigator/push', {
					extends: destinationComponent,
				});

				this.$store.commit('splitter/toggle');
			}
		},
		computed: {
			avatar() {
				return this.$store.state.shared.avatar;
			},
			names() {
				return this.$store.state.shared.names;
			},
			version () {
				return process.env.VUE_APP_VERSION;
			}
		}
	}
</script>

<style scoped>
	.background{background: #181818}
	.menu-profil img.list-item__thumbnail {
		object-fit: cover;
		width: 60px;
		height: 60px;
	}
	.menu-profil .center {
		font-size: 18px;
		word-spacing: 114px;
	}
	.menu-profil .left {
		margin-right: 16px;
		min-width: 60px;
	}
	.qf-menu-people-avatar img {
		width: 60px;
		border-radius: 50%;
		height: 60px;
		object-fit: cover;
	}

	.qf-menu-item .ons-icon {
		color: #cbc1b7;
		margin-right: 15px;
		font-size: 30px;
	}
	.version {
		position: absolute;
		bottom: 10px;
		right: 15px;
		font-weight: 700;
		font-size: 14px;
	}
	@media (orientation: portrait){
		html[onsflag-iphonex-landscape] .background:before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 45px;
			background-color: #363636;
		}
	}
</style>
